import React, {Component} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography, CircularProgress} from '@mui/material';
import Api from '../../api';
import {EDIT_DLT_URL} from '../../lib/constant';

export default class EditDLT extends Component {
  constructor(props){
    super(props);
    this.state={
      val : props.dltPrincipalEntityId || '',
      error: '',
      saving: false
    }
  }
  handleEditDLT = async () =>{
    let {val} = this.state;
    if(!val.trim().length){
      this.setState({error: 'DLT ID is required'});
      return;
    }
    this.setState({error: '', saving: true});
    try {
      const url = EDIT_DLT_URL.replace('{instId}', this.props.tenantId);
      await Api.put(url, {dlt_principal_entity_id: val.trim()});
      this.props.onSuccess();
    } catch (err) {
      const msg = err?.response?.data?.message || err?.response?.data?.error || err?.message || 'Failed to update DLT ID';
      this.setState({error: msg, saving: false});
    }
  }
  render(){
    const {val, error, saving} = this.state;
    return(
      <Dialog
        open={true}
        onClose={this.props.toggleEditDLTId}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit DLT ID</DialogTitle>
        <DialogContent style={{paddingTop: 16}}>
          <TextField
            label="Enter DLT ID"
            value={val}
            fullWidth
            required
            variant="standard"
            error={!!error}
            helperText={error}
            inputProps={{style: {fontSize: 16, letterSpacing: 0.5}}}
            onChange={(e)=>{this.setState({val : e.target.value, error: ''})}} />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.toggleEditDLTId} disabled={saving}>Cancel</Button>
          <Button onClick={this.handleEditDLT} variant='contained' disabled={saving}>
            {saving ? <CircularProgress size={20} /> : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}
